import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Box, ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import SatelliteAltOutlinedIcon from "@mui/icons-material/SatelliteAltOutlined";
import { setTileLayer } from "../reducers/MapSlice";

const BASE_MAPS = [
  { key: "satellite", Icon: SatelliteAltOutlinedIcon },
  { key: "defaultmap", Icon: MapOutlinedIcon },
];

export const toggleSx = {
  "& .MuiToggleButton-root": {
    px: 1.25,
    py: 0.25,
    border: "none",
    borderRadius: "8px !important",
    textTransform: "none",
    fontSize: 12,
    fontWeight: 600,
    color: "text.secondary",
  },
  "& .MuiToggleButton-root.Mui-selected, & .MuiToggleButton-root.Mui-selected:hover":
    { bgcolor: "primary.main", color: "#fff" },
};

export default function BaseMapToggle({ value, disableSatellite }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const onChange = (layer) => {
    dispatch(setTileLayer(layer));
    localStorage.setItem("tileLayer", layer);
  };

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={value}
      onChange={(_, layer) => layer && onChange(layer)}
      aria-label={t("map.bar.baseMap")}
      sx={[
        toggleSx,
        {
          border: "1px solid rgba(0,0,0,0.12)",
          borderRadius: "10px",
          p: 0.25,
          "& .MuiToggleButton-root": { p: 0.5 },
        },
      ]}
    >
      {BASE_MAPS.map(({ key, Icon }) => {
        const label = t(`map.bar.${key}`);
        return (
          <ToggleButton
            key={key}
            value={key}
            aria-label={label}
            disabled={key === "satellite" && disableSatellite}
          >
            {/* no hover if disabled, tooltip only */}
            <Tooltip
              title={
                key === "satellite" && disableSatellite
                  ? t("map.bar.satelliteUnavailable")
                  : label
              }
            >
              <Box
                component="span"
                sx={{ display: "flex", pointerEvents: "auto" }}
              >
                <Icon sx={{ fontSize: 18 }} />
              </Box>
            </Tooltip>
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
}
